<template lang="pug">
  .color-kit-swatch-selector
    .more-colors-wrap
      button.more-colors.swatch-wrap.btn-reset.xs-f-small.max-at-tweak(type="button" ref="moreColors" @click="seeMoreColors(true, $refs.moreColors)" data-mr-ass="see-more-colors")
        .non-focusable(tabindex="-1")
          .swatch
            .swatch-inner
              .icon-pos.hv-center.color-white.xs-f-xlarge.max-at-tweak
          span.swatch-text.color-slate.xs-f-xsmall.max-at-tweak More<br/> colors

    
    horizontal-selector.swatches-wrap(:selected-index="currentSlide")
      button.swatch-wrap.btn-reset.xs-f-small.max-at-tweak(v-for="(match, index) in formatedColorMatches" :key="index" @click="selectMatch(match, index)" :class="{selected: match.product.code == product.code}" tabindex="0")
        .non-focusable(tabindex="-1")
          .swatch
            .swatch-inner
              img.full-width(:src="match.product.imagery.toneSwatch.url" alt="")
          span.swatch-text.color-slate.xs-f-xsmall.max-at-tweak(v-html="match.label" :class="{'bold': match.product.code == product.code}")

</template>

<script>
  import { mapState, mapActions } from 'vuex';

  export default {
    name: "ColorKitSwatchSelector",

    data() {
      return {
        currentSlide: 0
      }
    },

    computed: {
      ...mapState('pdp', ['product']),

      advisorComplete() {
        return this.$root.advisorComplete;
      },

      colorMatches() {
        return this.$root.colorMatches;
      },

      formatedColorMatches() {
        return this.$root.formatedColorMatches;
      }
    },

    methods: {
      ...mapActions('pdp', ['openPlaygroundModal']),

      seeMoreColors(viewOnModel, elementRef) {
        if (!this.advisorComplete) {
          window.location = '/color-advisor?rectype=color';
        } else {
          this.openPlaygroundModal({
            props: {
              viewOnModel: viewOnModel
            },
            returnFocusElement: elementRef
          });
        }
      },

      selectMatch(match, index) {
        this.currentSlide = index;
        this.$router.push('/product/' + match.product.url_key);
      },

      update() {
        this.formatedColorMatches.forEach((match, index) => {
          if (this.product.code == match.product.code) {
            this.currentSlide = index;
          }
        });
      }
    },

    watch: {
      product() {
        this.update();
      }
    },

    mounted() {
      var unwatchFormatedColorMatches = this.$watch('formatedColorMatches', () => {
        this.update();
        unwatchFormatedColorMatches();
      });
    }
  }
</script>

<style lang="stylus">
  .color-kit-swatch-selector
    position relative
    padding 1em 0
    
    .more-colors-wrap
    .swatches-wrap
      display inline-block
      vertical-align top
      
    .more-colors-wrap
      width 20%
      
    .swatches-wrap
      position relative
      width 80%
      overflow hidden
      
      &:before
      &:after
        content ''
        position absolute
        top 0
        bottom 0
        width 1.5em
        pointer-events none
        z-index 2
        
      &.left-overflow
        &:before
          left -0.1em
          background linear-gradient(to right, rgba(255, 255, 255, 0.75) , rgba(255, 255, 255, 0))
          background -webkit-linear-gradient(left, rgba(255, 255, 255, 0.75), rgba(255, 255, 255, 0))
        
      &.right-overflow
        &:after
          right -0.1em
          background linear-gradient(to right, rgba(255, 255, 255, 0) , rgba(255, 255, 255, 0.75))
          background -webkit-linear-gradient(left, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.75))
    
    .swatch-wrap
      display inline-block
      vertical-align top
      width 5.25em
      padding-right 0.25em
      text-align center
      white-space normal
      
      .swatch
        display inline-block
        width 5em
        height 5em
        border-radius 50%
        padding 4px
        border 4px solid color-white
        
        .swatch-inner
          position relative
          width 100%
          height 100%
          border-radius 50%
          overflow hidden
          
      &.selected
        .swatch
          border-color color-mr-blue
      
      .swatch-text
        display inline-block
        margin-top 0.25em
    
    .more-colors
      .swatch-inner
        background-color color-mr-purple
        
    @media mq-mobile
      .more-colors-wrap
        width 21%
        
      .swatches-wrap
        width 79%
        
      .swatch-wrap
        width 4.5em
        
        .swatch
          width 4.5em
          height 4.5em
          
    @media mq-tablet
      .more-colors-wrap
        width 16.5%
        
      .swatches-wrap
        width 83.5%
        
        .carousel
          width 25em
    
    @media mq-desktop-md
      .more-colors-wrap
        width 26%
        
      .swatches-wrap
        width 74%
        
        .carousel
          width 10em
    
</style>
